import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractSalaryPeriod  {
    _originalTypeClassName = "zERP.BO.EmployeeContractSalaryPeriod";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractSalaryPeriod.translate = translateService;
}
this.Id = null;
this.Weight = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Weight:any;
SalaryPeriod:any;
EmployeeContract:any;
EmploymentContractTemplate:any;
static setSalaryPeriod = ($this, value) => {
var oldValue = $this.SalaryPeriod;
$this.SalaryPeriod = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
if (oldValue != null) {
Domain.EmployeeContract.removeSalaryPeriods(oldValue, $this);
}
Domain.EmployeeContract.addSalaryPeriods(value, $this);
}
}
static setEmploymentContractTemplate = ($this, value) => {
var oldValue = $this.EmploymentContractTemplate;
$this.EmploymentContractTemplate = value;
if (value != null) {
if (oldValue != null) {
Domain.EmploymentContractTemplate.removeSalaryPeriodConfig(oldValue, $this);
}
Domain.EmploymentContractTemplate.addSalaryPeriodConfig(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}